export default __webpack_public_path__ + "static/media/eas.c3c5b23b.svg";